import Hero from "../designSystem/Hero";
import SEO from "../designSystem/SEO";
import AboutChris from "../../assets/images/aboutus_chris.png";
import AboutMichael from "../../assets/images/aboutus_michael.png";
import TeamAdvice from "../../assets/images/aboutus_meettheteam.png";
import AboutBanner from "../../assets/images/aboutus_banner.png";
import { ReactComponent as PersonalIcon } from "../../assets/icons/personal.svg";
import { ReactComponent as HonestIcon } from "../../assets/icons/honest.svg";
import { ReactComponent as ProfessionalIcon } from "../../assets/icons/professional.svg";
import { ReactComponent as ResponsiveIcon } from "../../assets/icons/responsive.svg";

const values = [
  {
    title: "Personal",
    icon: PersonalIcon,
    description: "Every recommendation starts with understanding you.",
  },
  {
    title: "Honest",
    icon: HonestIcon,
    description: "Clear advice without jargon or unnecessary complexity.",
  },
  {
    title: "Professional",
    icon: ProfessionalIcon,
    description:
      "Experienced advisers committed to achieving the right outcome.",
  },
  {
    title: "Responsive",
    icon: ResponsiveIcon,
    description:
      "Keeping you informed and making the mortgage process as smooth as possible.",
  },
];

const ValueIcon = ({ icon: Icon }) => (
  <span
    className="row-center bg-gray-3 p-s all-radius-m text-primary-2"
    aria-hidden="true"
  >
    <Icon />
  </span>
);

const AboutUsPage = () => {
  return (
    <div>
      <SEO
        title="About TAG Mortgages"
        description="Learn about TAG Mortgages, our values and our personal, straightforward approach to mortgage advice."
        path="/about-us"
      />

      <Hero
        title="About Us"
        // subtitle="TAG Mortgages"
        backgroundImage={AboutBanner}
        showContactButton={false}
      />

      <section className="background-container bg-gray-3">
        <div className="content-container ">
          <div className="column-center gap-l">
            <div className="body2 text-primary-2 uppercase">- ABOUT US</div>
            <h2 className="h4 text-primary-1">About TAG Mortgages</h2>
            <div className="column-center gap-m text-center">
              <div className="content text-gray-1">
                At TAG Mortgages, we believe great mortgage advice is about more
                than finding a competitive interest rate, it's about
                understanding people.
              </div>
              <div className="content text-gray-1">
                Our advisers work with individuals, families, landlords and
                business owners across the UK, providing honest, practical
                advice tailored to each client's circumstances. We know that
                buying a home or arranging finance can feel overwhelming, so our
                aim is to make the process straightforward, transparent and
                stress-free.
              </div>
              <div className="content text-gray-1">
                We combine expert knowledge with a personal approach, taking the
                time to understand your goals before recommending solutions that
                fit your needs.
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="background-container bg-white">
        <div className="content-container">
          <div className="column gap-l">
            <div className="body2 text-primary-2 uppercase">
              - WHAT DRIVES US
            </div>
            <h2 className="h4 text-primary-1">Our Values</h2>
            <div className="grid4 ">
              {values.map((value) => (
                <article
                  className="column-center gap-l bg-white p-l"
                  key={value.title}
                >
                  <ValueIcon icon={value.icon} />
                  <div className="subtitle-semibold text-primary-1 text-center">
                    {value.title}
                  </div>
                  <div className="content text-gray-1 text-center">
                    {value.description}
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="background-container bg-primary-1">
        <div className="content-container">
          <h2 className="h4 text-white text-center">
            At TAG Mortgages, we're proud that many of our clients return to us
            time and again, recommending us to family, friends and colleagues.
            Building long-term relationships is at the heart of everything we
            do.
          </h2>
        </div>
      </section>

      <section className="background-container bg-gray-3">
        <div className="content-container">
          <div className="column gap-l">
            <div className="body2 text-primary-2 uppercase">- OUR TEAM</div>
            <h2 className="h4 text-primary-1">Meet The Team</h2>
            <article className="column gap-l bg-white p-l all-radius-m">
              <img
                src={TeamAdvice}
                alt="The TAG Mortgages adviser team"
                className="hero-image height-auto all-radius-0"
              />
              <div className="content text-gray-1">
                The team at TAG Mortgages combines extensive industry knowledge
                with a genuinely personal approach to mortgage and protection
                advice. Every member of our team is committed to understanding
                your individual circumstances, providing clear guidance and
                delivering tailored solutions that support your financial goals.
                From your first enquiry through to completion and beyond, we
                work closely together to make the process as straightforward and
                stress-free as possible. By building long-term relationships
                based on trust, professionalism and exceptional service, we're
                here to provide expert support whenever you need us, helping you
                move forward with confidence at every stage of your property
                journey.
              </div>
            </article>
            {/* <article className="column gap-m bg-white p-l all-radius-m">
            </article> */}
            <div className="grid2 grid-stretch gap-l">
              <article className="column gap-m bg-white p-l all-radius-m">
                <img
                  src={AboutChris}
                  alt="Chris Hewitt, director and mortgage adviser at TAG Mortgages"
                  className="hero-image height-auto"
                />
                <h3 className="h4 text-primary-1">Chris Hewitt</h3>
                <div className="body2-semibold text-primary-2 uppercase">
                  DIRECTOR - RESIDENTIAL, BUY TO LET AND COMMERCIAL BROKER
                </div>{" "}
                <div className="column gap-m">
                  <div className="content text-gray-1">
                    Chris started his career in financial services in 1995
                    providing advice to clients and companies in the pension,
                    investment and protection arena for the Prudential before
                    moving to John Charcol as a Senior Consultant / Mortgage
                    Broker, predominantly dealing with High Net Worth
                    Individuals and assisting with complex prime and larger Buy
                    to Let Portfolios.​
                  </div>
                  <div className="content text-gray-1">
                    After a spell as a founding broker with Capital Private
                    Finance, starting in 2010, which became one of the premier
                    brokerages in London, Chris established his own brokerage
                    CAPC and set up TAG Mortgages in 2018 to provide a branded
                    solution for the network and our clients.
                  </div>
                </div>
              </article>

              <article className="column gap-m bg-white p-l all-radius-m">
                <img
                  src={AboutMichael}
                  alt="Michael Batchelor, director and mortgage adviser at TAG Mortgages"
                  className="hero-image height-auto"
                />
                <h3 className="h4 text-primary-1">Michael Batchelor</h3>
                <div className="body2-semibold text-primary-2 uppercase">
                  DIRECTOR - RESIDENTIAL, BUY TO LET AND COMMERCIAL BROKER
                </div>
                <div className="column gap-m">
                  <div className="content text-gray-1">
                    Michael is a director and mortgage adviser at TAG Mortgages
                    providing Residential & Buy to Let mortgage solutions to a
                    diverse range of clients including First Time Buyers, High
                    Net Worths and Portfolio Landlords. Having originally
                    started his career in tax and accountancy he progressed into
                    mortgage advice where he works predominantly with property
                    agents, accountants and financial advisers to provide
                    bespoke solutions for their clients. Alongside CAPC, Michael
                    is also a director and adviser at Christopher Allen Private
                    Clients.
                  </div>
                  <div className="content text-gray-1">
                    Michael has been in the industry for over 10 years and has
                    achieved High Achievers Status on multiple occasions.
                  </div>
                  <div className="content text-gray-1">
                    Outside of mortgage advice, Michael is a portfolio landlord
                    with properties in both personal name and limited company
                    and he is chairman of a local adult’s football club.
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>

      <section className="background-container bg-primary-1">
        <div className="content-container">
          <div className="column-center gap-l">
            <div className="body-2  text-white uppercase">
              - LET’S GET YOU MOVING
            </div>
            <h2 className="h4 text-white text-center">
              Whether you're taking your first step onto the property ladder or
              expanding your investment portfolio, TAG Mortgages is here to
              help.
            </h2>
            <div className="content text-white text-center">
              Get in touch today and discover how simple arranging your mortgage
              can be.
            </div>
            <div className="body1 text-white">
              Your home may be repossessed if you do not keep up repayments on
              your mortgage.
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUsPage;
